import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://elnacain.com/wp-content/uploads/2022/03/indeed-job-ad-768x480.jpg"
                  alt="indeed"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Indeed </h2>
              <p>
              Indeed is an employment website for job listings. Built on tech stack React,Redux,NodeJs,HTML,CSS and javaScript we used Chakra UI for styling . It's a team project completed executed in 5 days.
              </p>
              <div>

                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
               
              </div>
              <div>
                <a
                  href="https://indeed-clone-tawny.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Premprakas7/Indeed.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/101813593/187067344-532d5701-f9d7-4baa-81d4-ff1872bf47a8.PNG"
                  alt="indeed"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Everhour </h2>
              <p>
              Everhour is a team-oriented time tracking software product. Built on tech stack React,Redux,NodeJs,HTML,CSS and javaScript we used Chakra UI for styling . It's a team project completed executed in 5 days.
              </p>
              <div>

                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
               
              </div>
              <div>
                <a
                  href="https://everhour-clone-1.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/gkomsai/cumbersome-circle-9157"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>


        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://i0.wp.com/www.indiaretailing.com/wp-content/uploads/2016/04/SS.jpg?resize=640%2C453"
                  alt="ShopperStop"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>ShopperStop Clone</h2>
              <p>
                First Backend Project with NodeJS, ExpressJS and MongoDB. Used EJS to render views. Main functionalities were : Register/Login using JWT, Sorting and Filtering in the backend, Cart and Wish List and many more.
              </p>
              <div>
                <IoLogoJavascript />
                <FaReact />
                <SiNodedotjs />
                <SiExpress />
                <SiMongodb />
              </div>
              <div>
                <a
                  href="https://unit3-shopper-stop.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Premprakas7/unit4_ShopperStop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
  

        
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://www.cashjosh.com/wp-content/uploads/2021/08/nemedfs-1024x524.png"
                  alt="Netmeds"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Netmeds </h2>
              <p>
                Clone of the popular epharma website called netmeds. Built on HTML,CSS and JavaScript . It's a team project completed executed in 5 days.
              </p>
              <div>

                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
               
              </div>
              <div>
                <a
                  href="https://snazzy-figolla-e0fb52.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Premprakas7/NetMeds"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};
